export const DRAG_HIGHLIGHT_CLASSES = 'bg-primary/10 ring-2 ring-inset ring-primary/30';
export const DRAG_HIGHLIGHT_WITH_PADDING =
  'bg-primary/10 ring-2 ring-inset ring-primary/30 rounded-lg p-2';

export function getDragHighlightClass(isDraggingOver: boolean, withPadding = true): string {
  if (!isDraggingOver) return '';
  return withPadding ? DRAG_HIGHLIGHT_WITH_PADDING : DRAG_HIGHLIGHT_CLASSES;
}
